import { createGlobalStyle } from "styled-components";

import ModeratLight from "./fonts/Moderat-Light.ttf";
import ModeratThin from "./fonts/Moderat-Thin.ttf";
import Georgia from "./fonts/georgia.ttf";
import Purisa from "./fonts/Mallanna-Regular.ttf";
import Sahel from "./fonts/Sahel.ttf";
import Iran from "./fonts/IRAN.woff";
import Iransans from "./fonts/IRANSans-web.woff";
import Shabnam from "./fonts/Shabnam-FD.ttf";
import Sade from "./fonts/A-Sade.ttf";
import Ziba from "./fonts/Far_Ziba.ttf";
import Tanha from "./fonts/Tanha-FD.ttf";




const GlobalStyles = createGlobalStyle`

@font-face {
    font-family: ModeratLight;
    src:url(${ModeratLight});
    font-weight: 100;
    font-style: normal;
}

@font-face {
    font-family: Purisa;
    src:url(${Purisa});
    font-weight: 100;
    font-style: normal;
}

@font-face {
    font-family: Georgia;
    src:url(${Georgia});
    font-weight: 100;
    font-style: normal;
}

@font-face {
    font-family: ModeratThin;
    src:url(${ModeratThin});
    font-weight: 100;
    font-style: normal;
}

@font-face {
    font-family: Sahel;
    src:url(${Sahel});
    font-weight: 100;
    font-style: normal;
}


@font-face {
    font-family: Iran;
    src:url(${Iran});
    font-weight: 100;
    font-style: normal;
}

@font-face {
    font-family: Sade;
    src:url(${Sade});
    font-weight: 100;
    font-style: normal;
}

@font-face {
    font-family: Ziba;
    src:url(${Ziba});
    font-weight: 100;
    font-style: normal;
}


@font-face {
    font-family: Tanha;
    src:url(${Tanha});
    font-weight: 100;
    font-style: normal;
}



html {
  box-sizing: border-box;
  }


* {
  margin: 0;
  padding: 0;
  /* color: black; */
  box-sizing: border-box;
}

ul {
  list-style-type: disc; /* Ensures bullets are visible */
  padding-left: 1.5rem;  /* Restores indentation */
  margin: 0;            /* Avoid unnecessary margins */
}

li {
  /* margin-bottom: 0.5rem;  */
}


body {
  /* color: #333; */
  color: ${(props) => props.theme.colors.txt.color1};
  /* background:${(props) => props.theme.colors.colorbg0}; */
  

  font-family: ${(props) =>
    props.lang === "fa" ? "Sahel, sans-serif" : "ModeratThin, sans-serif"};
  font-weight: 400;
  display: flex;
  flex-direction: column;
  /* width: 94%; */
  /* max-width: 94%; */
  line-height: 1.5;
}

html, body {
  height: 100%;
}

main {
  /* margin: 0 clamp(1px, 5vw, 100px); */
  /* background-color: #f3b5ff; */
}

`;

export default GlobalStyles;
